import candidateFiltersReducer from './candidateFilters'
import candidatesReducer from './candidates'
import impressionsReducer from './impressions'
import infiniteScrollReducer from './infiniteScroll'
import lastViewedCandidateReducer from './lastViewedCandidate'
import positionsReducer from './positions'
import stickyFiltersReducer from './stickyFilters'
import notifications from './notifications'

import * as candidateFiltersModule from './candidateFilters'
import * as candidatesModule from './candidates'
import * as impressionsModule from './impressions'
import * as infiniteScrollModule from './infiniteScroll'
import * as lastViewedCandidateModule from './lastViewedCandidate'
import * as positionsModule from './positions'
import * as stickyFiltersModule from './stickyFilters'
import * as notificationsModule from './notifications'

export {
  candidateFiltersModule,
  candidatesModule,
  impressionsModule,
  infiniteScrollModule,
  lastViewedCandidateModule,
  positionsModule,
  stickyFiltersModule,
  notificationsModule,
}

export default {
  candidateFilters: candidateFiltersReducer,
  candidates: candidatesReducer,
  impressions: impressionsReducer,
  infiniteScroll: infiniteScrollReducer,
  lastViewedCandidate: lastViewedCandidateReducer,
  positions: positionsReducer,
  stickyFilters: stickyFiltersReducer,
  notifications,
}
